import { FormStatus } from './enum';

export const ADDRESS_COOKIE_NAME = 'address';

export const TRACKING_STEP_PERSONAL_DETAILS = 'personal details';
export const TRACKING_STEP_CONFIRMATION = 'confirmation';
export const TRACKING_INFORMATION_ACTION_REVEAL = 'reveal';
export const TRACKING_TRIGGER_REFERENCE_FOOTNOTE = 'reference footnote';
export const TRACKING_ADDITIONAL_PAGE_LEVELS = [
    TRACKING_STEP_PERSONAL_DETAILS,
    TRACKING_STEP_CONFIRMATION,
];
export const TRACKING_PAGE_VIEW = 'pageview';
export const TRACKING_INFORMATION = 'information';
export const TRACKING_STEP_MAP = {
    start: {
        formStep: '1',
        formStepName: TRACKING_STEP_PERSONAL_DETAILS,
        formStatus: [FormStatus.START],
    },
    success: {
        formStep: '2',
        formStepName: TRACKING_STEP_CONFIRMATION,
        formStatus: ['end', FormStatus.SUCCESS],
    },
    failure: {
        formStep: '2',
        formStepName: TRACKING_STEP_CONFIRMATION,
        formStatus: ['end', FormStatus.FAILURE],
    },
};
export const NAME_FOOTNOTE = 'footnote';
export const NAME_ACCORDION = 'accordion';
